<div class="campaign-overview-component" [ngClass]="{ 'py-4 px-3': !isCampaignProjects }">
  <!--change start-->
  @if (!isProjectCollapse) {
    <div class="mt-4">
      <div class="d-block">
        <div class="d-none d-md-block">
          <div class="d-flex align-items-center page-tab-control">
            <div class="section-title d-flex align-items-center w-100">
              <div class="d-flex align-items-center pointer">
                <span class="px-3 no-wrap">{{ 'All Projects' | translate }}</span>
              </div>
            </div>
            <div class="d-flex align-items-center ms-auto project-nav-tabs">
              <div
                class="tab-item pointer text-center"
                (click)="allProjectItems(); activeTab = 'all'"
                [ngClass]="{ active: isAllProject }">
                <span>{{ 'All' | translate }}</span>
              </div>
              <div
                class="tab-item pointer text-center"
                (click)="favoriteProjectItems(); activeTab = 'Fav'"
                [ngClass]="{ active: isFavoritesProject }">
                <span>{{ 'Favorites' | translate }}</span>
              </div>
              <div
                class="tab-item pointer text-center"
                (click)="getArchiveProjects(); activeTab = 'Archived'"
                [ngClass]="{ active: isArchivedProject }">
                <span>{{ 'Archived' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  }
  <!-- change end-->

  @if (!isLoaded && !isError) {
    <div class="skeleton mt-3">
      <mtm-grid-skeleton
        [borderRadius]="6"
        [gridCount]="9"
        [widthSizeInPixels]="180"
        [HeightSizeInPixels]="235"></mtm-grid-skeleton>
    </div>
  }

  <div class="projects-list position-relative w-100">
    @if (canCreateProject && isStandAlone && projects.length == 0 && isLoaded && !isError) {
      <div class="project pointer" [style.min-height]="'292px'">
        <div
          class="campaign-drive-btn d-flex justify-content-center align-items-center w-100 h-100"
          (click)="createProject()">
          <button
            class="btn btn-orange text-uppercase position-relative btn-new-project text-nowrap py-1 px-4"
            [style.min-width]="'100px'"
            [style.width]="'auto'"
            (click)="createProject()">
            <i class="p-1 fa fa-plus" aria-hidden="true"></i>
            <span class="ms-2">{{ 'newProject' | translate }}</span>
          </button>
        </div>
      </div>
    }

    @if (isError) {
      <div class="d-flex justify-content-center align-items-center w-75">
        <span class="_600 f-12">{{ 'dashboard_somethingWentWrong' | translate }}</span>
      </div>
    }

    @for (item of projects; track item) {
      <div
        class="pointer project project-item"
        (click)="redirectToDashboard(item)"
        [ngClass]="{ 'locked-project': item.locked }">
        <div>
          @if (item.locked) {
            <div class="lock-project-icon d-flex" (click)="$event.stopImmediatePropagation()">
              <div class="lock-icon-container d-flex align-items-center justify-content-center">
                <i class="mtm-icon mtm-icon-lock"></i>
              </div>
            </div>
          }

          <div class="card-img">
            @if (item.avatarUrl) {
              <img
                class="image-style"
                [src]="`${item.avatarUrl}?v=${cacheBuster}`"
                alt=""
                (error)="item.avatarUrl = null" />
            } @else {
              <img class="image-style" [src]="`/assets/img/random-img/project${($index % 20) + 1}.png`" alt="" />
              <span
                class="c-full-white profile-text text-uppercase h-100 w-100"
                [style.background-color]="timelineService.getColorFromName(item.name)">
                {{ item.name | slice: 0 : 2 }}
              </span>
            }
            <span class="badge badge-edit-button badge-edit-button--new-version">
              @if (!item.isFavorite) {
                <i
                  (click)="$event.stopImmediatePropagation(); markAsFavorite(item)"
                  class="fa fa-star-o"
                  aria-hidden="true"></i>
              }
              @if (item.isFavorite) {
                <i
                  (click)="$event.stopImmediatePropagation(); removeFavorite(item)"
                  class="fa fa-star"
                  [style.color]="'#ffca4c'"
                  aria-hidden="true"></i>
              }
            </span>
          </div>

          <div class="card card-project border-0 shadow-sm position-relative">
            <div class="col px-2 pb-2">
              @if (!item.locked) {
                <div class="d-flex met-top-info w-100">
                  <div class="col">
                    <span class="f-10 _700 pt-2 pb-1 brand-name _1-line-text-ellipsis" [style.color]="'#898C98'">
                      @if (shouldShowEllipsis(item?.workspaceName, 25)) {
                        <span [ngbTooltip]="item.workspaceName">
                          {{ item.workspaceName }}
                        </span>
                      } @else {
                        {{ item.workspaceName }}
                      }

                      @if (item.campaignName) {
                        /
                        @if (shouldShowEllipsis(item.campaignName, 25)) {
                          <span [ngbTooltip]="item.campaignName">
                            {{ item.campaignName }}
                          </span>
                        } @else {
                          {{ item.campaignName }}
                        }
                      }
                    </span>
                  </div>
                </div>
              }

              <div class="d-flex w-100" [style.height]="'45px'">
                <div class="col">
                  <span
                    class="f-14 _700 c-full-black _1-line-text-ellipsis"
                    [ngbTooltip]="shouldShowEllipsis(item.name) ? item.name : null">
                    {{ item.name }}</span
                  >
                </div>
                @if (!item.locked) {
                  <div
                    class="pointer setting-gear-button setting-gear-button--new-version"
                    [class.archive-project]="item.deleted"
                    [style.height]="'20px'"
                    style="position: relative; top: -5px"
                    (click)="$event.stopImmediatePropagation()">
                    <div
                      ngbDropdown
                      autoCloseDropdown
                      class="dropdown"
                      container="body"
                      placement="bottom-right"
                      *ngIf="!isAgencyUser">
                      <div class="dropdown-toggle-container" ngbDropdownToggle>
                        <div class="three-dot-icon">
                          <span></span>
                          <span></span>
                          <span></span>
                        </div>
                      </div>
                      <div ngbDropdownMenu class="dropdown-menu-start arrow_box" aria-labelledby="dropdownMenuLink">
                        <div class="col options hover-text d34">
                          @if (!workspaceId && isWorkspaceEnabled) {
                            <div
                              ngbDropdownItem
                              class="col pointer p-0 d-flex align-items-center my-3"
                              (click)="gotoWorkspace(item)">
                              <i class="_500 fa fa-home fa-lg" [style.color]="'#181E39'" aria-hidden="true"></i>
                              <span class="ms-2 f-10 _700 text-uppercase"> {{ 'gotoWorkspace' | translate }}</span>
                            </div>
                          }
                          @if (item.campaignName) {
                            <div
                              ngbDropdownItem
                              class="col pointer p-0 d-flex align-items-center my-3"
                              (click)="gotoCampaign(item)">
                              <i class="_500 fa fa-rocket fa-lg" [style.color]="'#181E39'" aria-hidden="true"></i>
                              <span class="ms-2 f-10 _700 text-uppercase"> {{ gotoLabel | translate }}</span>
                            </div>
                          }
                          @if (canUpdateProjectRow(item)) {
                            <div
                              ngbDropdownItem
                              class="col pointer ps-0 d-flex align-items-center my-3"
                              (click)="editProject(item)">
                              <i class="_500 fa fa-pencil fa-lg" [style.color]="'#181E39'" aria-hidden="true"></i>
                              <span class="ms-2 f-10 _700"> {{ 'settings' | translate }}</span>
                            </div>
                          }
                          @if (
                            (item.status === projectStatusList.Completed ||
                              item.status === projectStatusList.ARCHIVED) &&
                            canDeleteProjectRow(item)
                          ) {
                            <div
                              ngbDropdownItem
                              class="col pointer p-0 d-flex align-items-center my-3"
                              (click)="archiveRestoreProject(item)">
                              <img
                                [style.color]="'#181E39'"
                                width="15"
                                height="12"
                                src="/assets/svg/archive-svg.svg"
                                alt="" />
                              <span class="ms-2 f-10 _700"> {{ !item.deleted ? 'ARCHIVE' : 'UNARCHIVE' }} </span>
                            </div>
                          }
                          @if (item.status === projectStatusList.ARCHIVED && canDeleteProjectRow(item)) {
                            <div
                              ngbDropdownItem
                              class="col pointer p-0 d-flex align-items-center my-3"
                              (click)="deleteProject(item)">
                              <i class="_500 fa fa-trash-o fa-lg" [style.color]="'#181E39'" aria-hidden="true"></i>
                              <span class="ms-2 f-10 _700"> DELETE </span>
                            </div>
                          }
                        </div>
                      </div>
                    </div>
                  </div>
                }
              </div>

              @if (!item.locked) {
                <div class="d-flex flex-column date-section w-100" style="height: 95px">
                  <div class="d-flex align-items-start justify-content-between w-100 pe-0 mt-2 mb-2" style="gap: 8px">
                    <div class="align-items-center col p-0 m-0" style="min-width: 0">
                      <span class="ms-1 d-flex f-10 _500 c-full-black text-uppercase">Start</span>
                      <span
                        class="f-10 _700 ms-1"
                        style="white-space: nowrap; overflow: hidden; text-overflow: ellipsis">
                        {{ parseTimestamp(item.startDate) | ngbDate }}
                      </span>
                    </div>
                    <div class="align-items-center col p-0 ms-auto m-0" style="min-width: 0">
                      <span class="ms-1 d-flex f-10 _500 c-full-black text-uppercase">End</span>
                      <span class="f-10 _700 ms-1">{{
                        parseTimestamp(item.completionDate || item.plannedEndDate) | ngbDate
                      }}</span>
                    </div>
                  </div>
                  <div
                    class="w-100 h-100 justify-content-between"
                    (click)="$event.stopImmediatePropagation()"
                    style="display: flex; align-items: flex-end; flex-wrap: wrap; gap: 8px">
                    <mtm-status-select
                      [value]="item.status"
                      [disabled]="!canUpdateProjectRow(item) || item.status === projectStatusList.ARCHIVED"
                      (click)="$event.stopImmediatePropagation()"
                      (valueChange)="changeProjectStatus(item, $event.value)" />
                    @if (!isStandAlone && isAssetListEnabled()) {
                      <div class="f-9 _500 project-item__asset px-2 py-1"
                        >{{ item?.assetList?.length ?? 0 }} Assets</div
                      >
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }

    @if (hasMorePages && !isError) {
      <div class="load-more-row d-flex justify-content-center align-items-center">
        @if (isLoadingMore) {
          <mtm-loading-spinner [size]="32" />
        }
        <!-- Observed instead of the row: pinned to its bottom edge, so the fetch starts only once
             the whole spinner is on screen. -->
        <div #loadMoreSentinel class="load-more-sentinel" aria-hidden="true"></div>
      </div>
    }
  </div>
</div>

<ng-template #searchPanel>
  <div class="d-flex flex-column flex-sm-row align-items-center search-panel w-auto">
    <div class="position-relative search-container ms-auto">
      <input
        [(ngModel)]="projectSearch"
        class="search-box ps-2 pe-4"
        (ngModelChange)="searchProject()"
        type="text"
        placeholder="{{ 'search' | translate }}" />
      <i class="fa fa-search search-icon" aria-hidden="true"></i>
    </div>
  </div>
</ng-template>
